import { render, staticRenderFns } from "./AdminConfiguration.vue?vue&type=template&id=0f27bafb&"
import script from "./AdminConfiguration.vue?vue&type=script&lang=js&"
export * from "./AdminConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports